import { CompInfo, MapperFunc, AnyCompDef } from '../types'

type Props = Record<string, any>

export const withCompInfo = <
	T extends Props,
	Def extends AnyCompDef,
	CarmiData = undefined,
	F extends keyof CompInfo<Def> = keyof CompInfo<Def>,
	Func = MapperFunc<F, T, Def, CarmiData>
>(
	depsArray: Array<F>,
	resolver: Func
): { resolver: Func; deps: Record<F, true> } => {
	const deps = depsArray.reduce((acc, key) => ({ ...acc, [key]: true }), {} as Record<F, true>)

	return { resolver, deps }
}
